import { AlertCircle } from "lucide-react";
import { useParams, useSearchParams } from "react-router-dom";
import { trpc } from "~/api/trpc";
import { PractitionerExternalConfigForm } from "~/components/practitioners/new-form/PractitionerExternalConfigForm";
import { PractitionerStammdatenForm } from "~/components/practitioners/new-form/PractitionerStammdatenForm";
import PractitionerScheduleManager from "~/components/practitioners/new-schedule-manager/PractitionerScheduleManager";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "~/components/ui/tabs";

interface Props {
    isAvailabilitiesVisible?: boolean;
}

const PractitionerForm = ({ isAvailabilitiesVisible = true }: Props) => {
    const params = useParams();
    const [searchParams] = useSearchParams();
    const practitionerId = params.id ? parseInt(params.id, 10) : null;

    const { data: practitionerData } = trpc.practitioners.getOne.useQuery(
        { id: practitionerId! },
        { enabled: !!practitionerId, refetchOnWindowFocus: false }
    );

    const ignoreAvailabilities = practitionerData?.practitioner_category?.ignoreAvailabilities ?? false;

    if (!practitionerId) {
        return (
            <div className="p-4 text-red-600 flex items-center gap-2">
                <AlertCircle className="h-5 w-5" />
                Fehler: Behandler-ID nicht gefunden.
            </div>
        );
    }

    return (
        <Tabs defaultValue={searchParams.get('tab') || "stammdaten"} className="w-full">
            <TabsList className="mb-4">
                <TabsTrigger value="stammdaten">
                    Stammdaten
                </TabsTrigger>
                {!ignoreAvailabilities && (
                    <TabsTrigger value="external">
                        Externe Konfiguration
                    </TabsTrigger>
                )}
                <TabsTrigger value="availability" disabled={!isAvailabilitiesVisible}>
                    Verfügbarkeiten
                </TabsTrigger>
            </TabsList>

            {/* Stammdaten Tab */}
            <TabsContent value="stammdaten">
                <PractitionerStammdatenForm practitionerId={practitionerId} />
            </TabsContent>

            {/* External Configuration Tab */}
            {!ignoreAvailabilities && (
                <TabsContent value="external">
                    <PractitionerExternalConfigForm practitionerId={practitionerId} />
                </TabsContent>
            )}

            {/* Availability Tab */}
            <TabsContent value="availability">
                <PractitionerScheduleManager practitionerId={practitionerId} />
            </TabsContent>
        </Tabs>
    );
};

export default PractitionerForm;
